import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { PaymentSuccessService } from './payment-success.service';
import { PaymentFailureService } from './payment-failure.service';

declare var paypal: any;

@Component({
  selector: 'app-paypal-button',
  template: '<div id="paypal-button-container"></div>',
})
export class PaypalButtonComponent implements OnInit {
  @Input() amount: number;
  @Input() description: string;
  @Input() orderId: string;
  @Output() dataEmitter: EventEmitter<string> = new EventEmitter();

  constructor(private paymentSuccessService: PaymentSuccessService,
              private paymentFailureService: PaymentFailureService) { }

  ngOnInit(): void {

    paypal.Buttons({style: {
        layout: 'horizontal',  // Questo imposta i pulsanti in orizzontale
        color:  'blue',        // Opzioni: 'gold', 'blue', 'silver', 'white', 'black'
        shape:  'rect',        // Opzioni: 'rect', 'pill'
        label:  'paypal',       // Opzioni: 'paypal', 'checkout', 'buynow', 'pay'
        height: 37
      },
      createOrder: (data, actions) => {
        return actions.order.create({
          purchase_units: [{
            description: this.description,
            amount: {
              value: this.amount.toString(),
              currency_code: 'EUR' // Forza l'utilizzo dell'euro
            },
            invoice_id: this.orderId
          }]
        });
      },
      onApprove: (data, actions) => {
        return actions.order.capture().then(details => {
          this.paymentSuccessService.handlePaymentSuccess(this.amount, details, this);
          // Qui puoi implementare ulteriori azioni post-pagamento
        });
      },
      onError: (err) => {
        this.paymentFailureService.handlePaymentFailure(this.amount, err, this);
      }
    }).render('#paypal-button-container');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/paypalButton/paypal-button.component.ts